export default "__VITE_ASSET__462a7e4e__"